import { useEffect, useState } from "react";
import { API } from "@/lib/api";

const TICKERS = ["NVDA", "EQIX", "DLR", "VRT"];

export const useHeroLiveStats = ({ jobsCount = 1 } = {}) => {
  const [state, setState] = useState({ jobs: null, stocks: [], allStocks: [], updatedAt: null, loading: true });
  useEffect(() => {
    const controller = new AbortController();
    const get = (path) => fetch(`${API}${path}`, { signal: controller.signal }).then((response) => (response.ok ? response.json() : Promise.reject(new Error(String(response.status)))));
    Promise.allSettled([get(`/jobs?page_size=${jobsCount}&sort=newest`), get("/stocks/market")]).then(([jobs, market]) => {
      if (controller.signal.aborted) return;
      const marketData = market.status === "fulfilled" ? market.value : null;
      const infra = marketData?.digital_infra || [];
      setState({
        jobs: jobs.status === "fulfilled" ? jobs.value : null,
        stocks: TICKERS.map((symbol) => infra.find((item) => item.symbol === symbol)).filter(Boolean),
        allStocks: infra,
        updatedAt: marketData?.updated_at || (jobs.status === "fulfilled" ? jobs.value.checked_at : null),
        loading: false,
      });
    });
    return () => controller.abort();
  }, [jobsCount]);
  return state;
};
